import { apiGeneric } from "src/core/helpers/api"
export default apiGeneric
